// @flow
import React from 'react'
import styled from 'styled-components'
import EmbeddedMap from 'components/shared/EmbeddedMap'
import { googleMapUrl } from 'frontend_core/dist/helpers/url'
import { mediaMax } from 'components/styles/_media'
import { zIndexes } from 'frontend_core/dist/styles/variables'
import Colors from 'components/styles/colors'

type PropTypes = {
  name: string,
  postalCode: string,
  stateText: string,
  city: string,
  address1: string,
  address2: string,
  access: string,
  latitude: number | string,
  longitude: number | string,
  googleMapReactBootstrapURLKeys?: ?Object,
}

const SideFixedPlace = styled.div`
  position: relative;
  z-index: ${zIndexes.child};
  ${mediaMax.desktop`
    margin-top: 16px;
  `};
`

const SpaceSide = styled.div`
  position: absolute;
  width: 346px;
  ${mediaMax.desktopLg`
    width: 277px;
  `}
  ${mediaMax.desktop`
    width: 100%;
    position: static !important;
  `}
  ${props =>
    props.isFixed
      ? `
    position: fixed;
  `
      : ''}
`

const SideBar = styled.div`
  border: 1px solid ${Colors.grayD};
  border-radius: 3px;
  background: #fff;
  margin-bottom: 32px;
  font-size: 13px;
`

const SideHeadLine = styled.h2`
  background: #eee;
  font-weight: bold;
  padding: 16px 18px;
  border-bottom: 1px solid ${Colors.grayD};
`

const SideMapContainer = styled.div`
  height: 400px;
  background-color: #b2ebf2;
  ${mediaMax.desktop`
    height: 200px;
  `};
`

const SideInner = styled.div`
  padding: 16px 18px;
  line-height: 1.5;
`

const SideMapAddress = styled.p``

const SideMapAccess = styled.p`
  color: #999;
  margin: 8px 0;
`

const MapUrlContainer = styled.p`
  &:hover {
    text-decoration: underline;
  }
`

export default (props: PropTypes) => {
  const {
    name,
    postalCode,
    stateText,
    city,
    address1,
    address2,
    access,
    latitude,
    longitude,
    googleMapReactBootstrapURLKeys,
  } = props
  const mapUrl = googleMapUrl(latitude, longitude, name)
  return (
    <SideFixedPlace className="col-sm-12 col-md-4">
      <SpaceSide>
        <SideBar>
          <SideHeadLine>{i18n.t('page.space.sidePlace')}</SideHeadLine>
          <SideMapContainer>
            <EmbeddedMap
              lat={parseFloat(latitude)}
              lng={parseFloat(longitude)}
              url={mapUrl}
              googleMapReactBootstrapURLKeys={googleMapReactBootstrapURLKeys}
            />
          </SideMapContainer>
          <SideInner>
            <SideMapAddress>
              {postalCode}
              <br />
              {`${stateText || ''}${city || ''}${address1 || ''}${address2 ||
                ''}`}
            </SideMapAddress>
            <SideMapAccess>{access}</SideMapAccess>
            <MapUrlContainer>
              <a href={mapUrl} target="_blank">
                {i18n.t('page.shared.openMap')}
              </a>
            </MapUrlContainer>
          </SideInner>
        </SideBar>
      </SpaceSide>
    </SideFixedPlace>
  )
}



// WEBPACK FOOTER //
// ./src/components/space/SidePlace.jsx